import React from 'react';
import Navbar2 from './components/Navbar2';
import Navbar from './components/Navbar';

import './App.css';
import Home from './components/pages/Home';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import Dyslexia from './components/pages/Dyslexia';
import Astar from './components/pages/ASTAR';
import GrowLah from './components/pages/GrowLah';
import Projectlithium from './components/pages/Projectlithium';
import SilverLion from './components/pages/SilverLion';
import Footer from './components/Footer';


function App() {
  return (
    <>
      <Router>
        <Switch>
          <Route path='/' exact>
            <Navbar />
            <Home />
          </Route>
          <Route path='/dyslexia'>
            <Navbar2 />
            <Dyslexia />
            <Footer />
          </Route>
          <Route path='/Astar'>
            <Navbar2 />
            <Astar />
            <Footer />
          </Route>
          <Route path='/GrowLah'>
            <Navbar2 />
            <GrowLah />
            <Footer />
          </Route>
          <Route path='/projectlithium'>
            <Navbar2 />
            <Projectlithium />
            <Footer />
          </Route>
          <Route path='/SilverLion'>
            <Navbar2 />
            <SilverLion />
            <Footer />
          </Route>
        </Switch>
      </Router>
    </>
  );
}

export default App;
